import { mockedIssues } from "@constants/mocked-image-challenge-data";
import type { ItemData } from "types/item";

import { useArticles } from "@features/articles/hooks/useArticles";
import useItems from "./useItems";

const SECTION_ITEM_LIMIT = 5;

const getRecentItems = (items: ItemData[] = []) => {
	const recent = items
		.sort((a, b) => {
			const dateA = a.publishedAt ? new Date(a.publishedAt) : new Date(0);
			const dateB = b.publishedAt ? new Date(b.publishedAt) : new Date(0);
			return dateB.getTime() - dateA.getTime();
		})
		.slice(0, SECTION_ITEM_LIMIT);

	return recent;
};

const mapItemsToDisplayFormat = (items: ItemData[]) => {
	return items.map((item) => ({
		id: item.id,
		title: item.data.stem,
		type: "challenge",
		tags: item.tags,
		accessType: item.accessType,
		updatedAt: item.updatedAt,
		imageUri: item.media?.[0]?.url || "https://placeholder.com/image.jpg",
		numResponses: item.numAttempts,
		description: `#${item.id}`,
		completed: item.completedAt != null,
	}));
};

export const useImageChallengeHome = () => {
	const { filteredItems, isLoading } = useItems();
	const { randomizedRecommendedArticles } = useArticles();

	const jbjsSectionList = [
		{
			title: "Recommended content",
			rightButtonProps: {
				cta: "More content",
				link: "/collections/issues?recommended=true",
			},
			data: [randomizedRecommendedArticles],
		},
		{
			title: "Latest issue",
			rightButtonProps: {
				cta: "Full issue",
				link: `/collections/issue/${mockedIssues[0].id}`,
			},
			data: [mockedIssues[0].articles],
		},

		{
			title: "Featured challenges",
			rightButtonProps: {
				cta: "More",
				link: "challenges/recent",
			},
			data: [mapItemsToDisplayFormat(getRecentItems(filteredItems))],
		},
	];

	const imageChallengeHomeSectionList = jbjsSectionList;

	const handleQuickActionPress = (_type?: string) => {
		//TODO: Handle quick action press based on the type
	};

	const quickActionsChips = [
		{
			label: "What's new in knee?",
			icon: "bullhorn-outline",
			tooltip: "What’s new in knee?",
		},
		{
			label: "Complete challenge",
			icon: "arm-flex-outline",
			tooltip: "Complete challenge",
		},
		{
			label: "Complete challenge",
			icon: "arm-flex-outline",
			tooltip: "Complete challenge",
		},
	];

	return {
		imageChallengeHomeSectionList,
		handleQuickActionPress,
		quickActionsChips,
		isLoading,
		flattenItems: filteredItems,
		featuredChallenge: undefined,
		nextChallenge: undefined,
	};
};
